import { GetTeamsPayloadModel, TeamForm, TeamSkill } from '@lichtblick/types';
import { getPreviousDay } from './date';

export const convertToBoolean = (value: string | null | undefined) => {
  if (!value) {
    return false;
  }

  return value === 'true';
};

export const regexMatch = (pathname: string) => {
  const regex = /^(\/qm\/orders(?:\/[0-9a-fA-F-]+)?|\/qm\/items)$/;

  return regex.test(pathname);
};

export const regexMatchItems = (pathname: string) => {
  const regex = /^\/qm\/orders\/[0-9a-fA-F-]+\/(items|categories|notes)$/;

  return regex.test(pathname);
};

export const parseBooleanParams = (params: { [x: string]: any }) => {
  const parsedParams: { [x: string]: any } = {};

  Object.keys(params).forEach((key) => {
    // Convert "true" and "false" strings to actual boolean values

    if (params[key] !== 'true' && params[key] !== 'false') {
      parsedParams[key] = params[key];
    } else {
      parsedParams[key] = params[key] === 'true';
    }
  });

  return parsedParams;
};

export const parseDateParams = (params: { [x: string]: any }) => {
  return {
    to: params['dateRange']?.['to'] ? new Date(params['dateRange']['to']) : new Date(),
    from: params['dateRange']?.['from'] ? new Date(params['dateRange']['from']) : getPreviousDay(),
  };
};

export const parseNumericFilterParams = (params: { [x: string]: any }) => {
  const parsedParams: { [x: string]: any } = {};
  //list of user filters that are numeric (Int)
  const numericFilters = ['branch', 'team', 'folderId', 'qualityManagerId'];

  Object.keys(params).forEach((key) => {
    if (!numericFilters.includes(key)) {
      parsedParams[key] = params[key];
    } else {
      parsedParams[key] = parseInt(params[key]);
    }
  });

  return parsedParams;
};

export const parseArrayCalendarFilterParams = (params: { [x: string]: any }) => {
  const parsedParams: { [x: string]: any } = {};
  const arrayCalendarFilters = ['branch', 'team', 'partner', 'appointmentType', 'person'];

  Object.keys(params).forEach((key) => {
    if (arrayCalendarFilters.includes(key)) {
      parsedParams[key] = JSON.parse(params[key]);
    }
  });

  return parsedParams;
};

export const convertTeamToForm = (team: GetTeamsPayloadModel): TeamForm => {
  const form: TeamForm = {
    id: team.id,
    branchId: team.branchOffice?.id.toString() ?? '',
    members: team.members ?? [],
    name: team.name ?? '',
    skills: team.skills
      ? team.skills
          .map(
            (skill) => ({ id: skill.workflowDefinition?.id, name: skill?.workflowDefinition?.name ?? '' }) as TeamSkill,
          )
          .filter((el) => !!el.id)
      : [],
  };

  return form;
};
